import axios from "axios";
import { JSON_URL } from "../../config/RouterLink";
import { openNotification } from "../../utils/funciones";
import { ERROR_INTERNET } from "../../utils/uiText";

//Aspirante
const SET_CAT_ESTADOS = "[CATALOGO] SET_CAT_ESTADOS";
const SET_CAT_MUNICIPIOS = "[CATALOGO] SET_CAT_MUNICIPIOS";
const SET_CAT_ESTADOS_EXT = "[CATALOGO] SET_CAT_ESTADOS_EXT";
const SET_CAT_MEDIOS_COMU = "[CATALOGO] SET_CAT_MEDIOS_COMU";

const SET_CAT_NIV_ESTUDIOS = "[CATALOGO] SET_CAT_NIV_ESTUDIOS";
const SET_CAT_AREA_ACADEMICA = "[CATALOGO] SET_CAT_AREA_ACADEMICA";
const SET_CAT_GRADO_AVANCE = "[CATALOGO] SET_CAT_GRADO_AVANCE";
const SET_CAT_DOC_OBTENIDO = "[CATALOGO] SET_CAT_DOC_OBTENIDO";

const SET_CAT_AREA_EXPERIENCIA = "[CATALOGO] SET_CAT_AREA_EXPERIENCIA";
const SET_CAT_REMUNERACION = "[CATALOGO] SET_CAT_REMUNERACION";

const SET_AVISO_PRIVACIDAD = "[CATALOGO] SET_AVISO_PRIVACIDAD";
const SET_LOADING_AVISO = "[CATALOGO] SET_LOADING_AVISO";
const SET_IS_PRUEBAS = "[CATALOGO] SET_IS_PRUEBAS";

const CLEAN_STATE = "[CATALOGO] CLEAN_STATE";

//------------- STATE -------------------------
const initialState = {
  // Aviso de privacidad
  avisoPrivacidad: {},
  avisoLoading: false,
  isPruebas: false,
  estados: [],
  medios: [],
  estadosExt: [],
  municipios: [],
  nivelEstudios: [],
  areaAcademica: [],
  gradoAvance: [],
  docObtenido: [],
  /*catalogos apartado experiencia*/
  areasExperiencia: [],
  remuneraciones: [],
};

//------------- REDUCER -------------------------
const catalogoReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_IS_PRUEBAS:
      return {
        ...state,
        isPruebas: action.payload,
      };
    case SET_CAT_ESTADOS:
      return {
        ...state,
        estados: [...action.payload],
      };

    case SET_CAT_MEDIOS_COMU:
      return {
        ...state,
        medios: [...action.payload],
      };

    case SET_CAT_ESTADOS_EXT:
      return {
        ...state,
        estadosExt: [...action.payload],
      };
    case SET_CAT_MUNICIPIOS:
      return {
        ...state,
        municipios: [...action.payload],
      };
    case SET_CAT_NIV_ESTUDIOS:
      return {
        ...state,
        nivelEstudios: [...action.payload],
      };
    case SET_CAT_AREA_ACADEMICA:
      return {
        ...state,
        areaAcademica: [...action.payload],
      };
    case SET_CAT_GRADO_AVANCE:
      return {
        ...state,
        gradoAvance: [...action.payload],
      };
    case SET_CAT_DOC_OBTENIDO:
      return {
        ...state,
        docObtenido: [...action.payload],
      };

    case SET_CAT_AREA_EXPERIENCIA:
      return {
        ...state,
        areasExperiencia: [...action.payload],
      };
    case SET_CAT_REMUNERACION:
      return {
        ...state,
        remuneraciones: [...action.payload],
      };
    case SET_AVISO_PRIVACIDAD:
      return {
        ...state,
        avisoPrivacidad: { ...action.payload },
      };

    case SET_LOADING_AVISO:
      // console.log("first", action.payload)
      return {
        ...state,
        avisoLoading: action.payload,
      };

    case CLEAN_STATE:
      return initialState;

    default:
      return state;
  }
};

export default catalogoReducer;

//------------- ACTIONS -------------------------
/**
 * Array de estados
 * @param {object[]} state
 * @returns
 */
export const setCatEstados = (state) => ({
  type: SET_CAT_ESTADOS,
  payload: state,
});

export const setCatMediosCom = (state) => ({
  type: SET_CAT_MEDIOS_COMU,
  payload: state,
});

export const setCatEstadosExt = (state) => ({
  type: SET_CAT_ESTADOS_EXT,
  payload: state,
});

/**
 * Array de municipios
 * @param {object[]} state
 * @returns
 */
export const setCatMunicipios = (state) => ({
  type: SET_CAT_MUNICIPIOS,
  payload: state,
});

export const cleanCatalogo = () => ({
  type: CLEAN_STATE,
});

/**
 * Función que obtiene el catálogo de estados.
 * @returns CatEstados[]
 */
export const getCatEstados = () => async (dispatch, getState) => {
  try {
    const urls = await axios(window.location.origin + JSON_URL);
    const { data } = await axios.post(
      `${urls.data.urlServer}${urls.data.urlCatEstados}`
    );
    dispatch(setCatEstados(data));
  } catch (error) {
    openNotification("error", ERROR_INTERNET, "");
  }
};

export const getCatMediosComunicacion = () => async (dispatch, getState) => {
  try {
    const urls = await axios(window.location.origin + JSON_URL);
    const { data } = await axios.post(
      `${urls.data.urlServer}${urls.data.urlCatMedios}`
    );
    dispatch(setCatMediosCom(data));
  } catch (error) {
    // openNotification("error", ERROR_INTERNET, "");
    console.error(error);
  }
};

/**
 * Función que obtiene el catálogo de estados con la opción de nacido en el extranjero.
 * @returns CatEstados[]
 */
export const getCatEstadosExt = () => async (dispatch, getState) => {
  try {
    const urls = await axios(window.location.origin + JSON_URL);
    const { data } = await axios.post(
      `${urls.data.urlServer}${urls.data.urlCatEstadosExt}`
    );
    dispatch(setCatEstadosExt(data));
  } catch (error) {
    openNotification("error", ERROR_INTERNET, "");
  }
};

/**
 * Función que obtiene el catálogo de municipios de acuerdo al idEstado.
 * @param {number} idEstado
 * @returns CatEstados[]
 */
export const getCatMunicipios = (idEstado) => async (dispatch, getState) => {
  try {
    const urls = await axios(window.location.origin + JSON_URL);
    const { data } = await axios.post(
      `${urls.data.urlServer}${urls.data.urlCatMunicipios}`,
      { idEstado }
    );
    dispatch(setCatMunicipios(data));
  } catch (error) {
    console.log(error);
    openNotification("error", ERROR_INTERNET, "");
  }
};

/**
 * Función que obtiene los catalagos para mostrar en la pantalla de requisitos académicos
 */
export const getAllCatalogos = () => async (dispatch, getState) => {
  try {
    const urls = await axios(window.location.origin + JSON_URL);
    //Urls a consultar
    let endpoints = [
      `${urls.data.urlServer}${urls.data.urlCatNivEstudios}`,
      `${urls.data.urlServer}${urls.data.urlCatArea}`,
      `${urls.data.urlServer}${urls.data.urlCatGradoAvance}`,
      `${urls.data.urlServer}${urls.data.urlCatDocObtenido}`,
    ];
    //Petición simultanea
    axios.all(endpoints.map((endpoint) => axios.post(endpoint))).then(
      axios.spread((nivEstudios, areas, grado, documentos) => {
        dispatch({ type: SET_CAT_NIV_ESTUDIOS, payload: nivEstudios.data });
        dispatch({ type: SET_CAT_AREA_ACADEMICA, payload: areas.data });
        dispatch({ type: SET_CAT_GRADO_AVANCE, payload: grado.data });
        dispatch({ type: SET_CAT_DOC_OBTENIDO, payload: documentos.data });
      })
    );
  } catch (error) {
    // openNotification("error", ERROR_INTERNET, "");
    console.error(error);
  }
};

export const getGradoAvance = (idGrado) => async (dispatch, getState) => {
  try {
    const urls = await axios(window.location.origin + JSON_URL);
    const { data } = await axios.post(
      `${urls.data.urlServer}${urls.data.urlCatGradoAvance}`,
      { idGrado }
    );
    dispatch({ type: SET_CAT_GRADO_AVANCE, payload: data });
  } catch (error) {
    openNotification("error", ERROR_INTERNET, "");
  }
};
export const getUrlUpload = () => async (dispatch, getState) => {
  const urls = await axios(window.location.origin + JSON_URL);
  return `${urls.data.urlServer}${urls.data.urlUpload}`;
};

/**
 * Obtiene los valores de la tabla PARAMETROS_GENERALES
 */
export const getValorParametro = (idValor) => async () => {
  try {
    const urls = await axios(window.location.origin + JSON_URL);
    return axios.post(
      `${urls.data.urlServer}${urls.data.urlParametroGeneral}`,
      {
        idValor,
      }
    );
  } catch (error) {
    console.log("Error en catalogo");
  }
};

/**
 * Función que valida si el aplicativo se mandará a seguridad o a pruebas de estres
 * @param {number} idValor
 * @returns
 */
export const getValorParametroPruebas = (idValor) => async (dispatch) => {
  try {
    const urls = await axios(window.location.origin + JSON_URL);
    const { data } = await axios.post(
      `${urls.data.urlServer}${urls.data.urlParametroGeneral}`,
      {
        idValor,
      }
    );
    // console.log(data.valorConfig === "1")
    dispatch({ type: SET_IS_PRUEBAS, payload: data.valorConfig === "1" });
  } catch (error) {
    console.log("Error en catalogo");
  }
};

export const getTextAvisoPrivacidad = () => async (dispatch) => {
  dispatch({ type: SET_LOADING_AVISO, payload: true });
  try {
    const urls = await axios(window.location.origin + JSON_URL);
    const { data } = await axios.post(
      `${urls.data.urlServer}${urls.data.urlAvisoPrivacidad}`
    );
    dispatch({ type: SET_AVISO_PRIVACIDAD, payload: data });
    dispatch({ type: SET_LOADING_AVISO, payload: false });
  } catch (error) {
    console.log("Error en catalogo");
  }
};

/**
 * Array de areas de experiencia
 * @param {object[]} state
 * @returns
 */
export const setCatAreaExperiencia = (state) => ({
  type: SET_CAT_AREA_EXPERIENCIA,
  payload: state,
});

/**
 * Función que obtiene el catálogo de c_areas_experiencia.
 * @returns areasExperiencia[]
 */
export const getAreasExperiencia = () => async (dispatch, getState) => {
  try {
    const urls = await axios(window.location.origin + JSON_URL);
    const { data } = await axios.post(
      `${urls.data.urlServer}${urls.data.urlCatAreaExperiencia}`
    );
    dispatch(setCatAreaExperiencia(data));
  } catch (error) {
    console.log(error);
    openNotification("error", ERROR_INTERNET, "");
  }
};

/**
 * Array de remuneraciones
 * @param {object[]} state
 * @returns
 */
export const setCatRemuneracion = (state) => ({
  type: SET_CAT_REMUNERACION,
  payload: state,
});

/**
 * Función que obtiene el catálogo de c_areas_experiencia.
 * @returns remuneraciones[]
 */
export const getRemuneraciones = () => async (dispatch, getState) => {
  try {
    const urls = await axios(window.location.origin + JSON_URL);
    const { data } = await axios.post(
      `${urls.data.urlServer}${urls.data.urlCatRemuneracion}`
    );
    dispatch(setCatRemuneracion(data));
  } catch (error) {
    console.log(error);
    openNotification("error", ERROR_INTERNET, "");
  }
};
